module.exports = __webpack_public_path__ + "assets/images/01.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/01.png
// module id = 1250
// module chunks = 1